import {
  AFTER_PAYMENT_PAYMENT_TYPE_ID,
  CREDIT_PAYMENT_TYPE_ID,
  CREDITS_PAYMENT_TYPE_ID,
  INVOICE_PAYMENT_TYPE_ID,
} from 'shared/consts/payment-method-types';

const NO_3DS_PAYMENT_METHOD_IDS = [
  CREDITS_PAYMENT_TYPE_ID,
  CREDIT_PAYMENT_TYPE_ID,
  INVOICE_PAYMENT_TYPE_ID,
  AFTER_PAYMENT_PAYMENT_TYPE_ID,
];

/**
 * Credits, invoice and after-payment methods never go through a card 3DS challenge.
 */
export const isNo3DSPaymentMethod = (paymentMethodId?: string | number | null): boolean =>
  paymentMethodId != null && NO_3DS_PAYMENT_METHOD_IDS.includes(paymentMethodId.toString());
